module.exports = __webpack_public_path__ + "static/media/carOld.d28b41a3.png";